var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageLibraryLoad = function SvgImageLibraryLoad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.9 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.6 12.7 2.3 2.4 1.4-.8L19 20l3.9-2 5.4 2.7v5H3.6v-7.1zm10.9-1h.7l-.2 1.1h-.3zm2.6-1 .7.9-.2.2-.9-.7zm-4.4 0 .5.5-.9.7-.3-.3zm4.9-2.1 1.1.2V9l-1.1.2zm-5.5 0v.7L17 9v-.2zM20.8 7c1.1 0 1.9.9 1.9 1.9 0 1.1-.9 1.9-1.9 1.9-1.1 0-1.9-.9-1.9-1.9 0-1.1.9-1.9 1.9-1.9m2.7-.9.2.2-.7.9-.5-.5zm-5.3 0 .9.7-.5.5-.6-1zM20.7 5h.3l.2 1.1h-.7zM2.2 2.4v24.4h27.2V2.4zM0 0h31.9v32H0z"
  })));
};
export { SvgImageLibraryLoad as ReactComponent };
export default __webpack_public_path__ + "assets/ImageLibraryLoad.13ef2ccc576249163431929f4d54ef79.svg";